let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("37V0d"), load("5vatq"), load("3YiKe")]).then(() => parcelRequire('bLtXM'));